import DynamicField from "./DynamicField";

export default DynamicField;



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/index.js